import React from 'react'

import 'wipe.css'
import '../../styles/GoatImport.css'
import '../../styles/Font.css'

import { MDXProvider } from '@mdx-js/react'
import Container from 'components/Container'
import CustomMDX from 'components/CustomMDX'
import GlobalStyle from 'components/GatsbyLayout/GlobalStyle'
import Header from 'components/Header'
import SideMenu from 'components/SideMenu'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { ThemeProvider } from 'theme'
import { TEMPLATE_IDS } from '../../../gatsby/utils'
import useWindowSize from '../../hooks/useWindowSize'
import ArticleLayout from '../ArticleLayout'
import { LayoutProvider, useLayoutContext } from '../LayoutContext'
import { NavigationStateProvider } from '../NavigationState'
import { PRIMARY_MENU_WIDTH, SIDE_MENU_WIDTH } from '../SideMenu/data'
import { LocationProvider } from '../LocationContext/LocationContext'

const SideMenuContainer = styled.div`
	position: fixed;
	top: 64px;
	left: 0px;
	bottom: 0px;
	z-index: 1;
	width: ${SIDE_MENU_WIDTH}px;

	transform: translateX(-100%);
	${p => p.theme.above('large')`
		transform: translateX(0%);
	`}

	${p =>
		!p.maxWidthToShowPrimaryMenuOpen &&
		p.theme.above('large')`
	width: ${SIDE_MENU_WIDTH}px;
	`}

	${p =>
		p.maxWidthToShowPrimaryMenuOpen &&
		p.theme.above('large')`
		width: ${PRIMARY_MENU_WIDTH}px;
`}

	${p =>
		p.maxWidthToShowPrimaryMenuOpen &&
		css`
			@media (min-width: ${p.maxWidthToShowPrimaryMenuOpen}px) {
				width: ${SIDE_MENU_WIDTH}px;
			}
		`}

	transition: transform 300ms ease;
`

const FakeSideMenu = styled.div`
	width: 0px;
	flex: none;

	${p =>
		!p.maxWidthToShowPrimaryMenuOpen &&
		p.theme.above('large')`
		width: ${SIDE_MENU_WIDTH}px;
		`}

	${p =>
		p.maxWidthToShowPrimaryMenuOpen &&
		p.theme.above('large')`
		width: ${PRIMARY_MENU_WIDTH}px;
`}

	${p =>
		p.maxWidthToShowPrimaryMenuOpen &&
		css`
			width: 0px;
			@media (min-width: ${p.maxWidthToShowPrimaryMenuOpen}px) {
				width: ${SIDE_MENU_WIDTH}px;
			}
		`}
	transition: all 300ms ease;
`

const ArticleLayoutWrapper = ({ children, props }) => {
	const { layoutProps } = useLayoutContext()
	return (
		<>
			<ArticleLayout {...layoutProps} location={props.location}>
				{children}
			</ArticleLayout>
		</>
	)
}

const ContentContainer = styled.div`
	flex: 1;
	width: 0px;
`

const MainLayout = ({ children, props }) => {
	const {
		location,
		pageContext: { layout },
	} = props

	const { layoutProps } = useLayoutContext()
	const { maxWidthToShowPrimaryMenuOpen } = layoutProps ?? {}

	const { width } = useWindowSize()

	return (
		<>
			<Header location={location} />
			<Container data-theme='light'>
				<SideMenuContainer maxWidthToShowPrimaryMenuOpen={maxWidthToShowPrimaryMenuOpen}>
					<SideMenu forcePrimaryMenuClose={width < maxWidthToShowPrimaryMenuOpen} location={location} />
				</SideMenuContainer>

				<FakeSideMenu maxWidthToShowPrimaryMenuOpen={maxWidthToShowPrimaryMenuOpen} />

				<ContentContainer>
					{layout === TEMPLATE_IDS.ARTICLE_LAYOUT ? (
						<ArticleLayoutWrapper props={props}>{children}</ArticleLayoutWrapper>
					) : (
						children
					)}
				</ContentContainer>
			</Container>
		</>
	)
}

GatsbyLayout.propTypes = { element: PropTypes.node }
export default function GatsbyLayout({ element, props }) {
	return (
		<LocationProvider location={props.location}>
			<ThemeProvider>
				<GlobalStyle />
				<NavigationStateProvider>
					<LayoutProvider>
						<MainLayout props={props}>
							<MDXProvider components={CustomMDX()}>{element}</MDXProvider>
						</MainLayout>
					</LayoutProvider>
				</NavigationStateProvider>
			</ThemeProvider>
		</LocationProvider>
	)
}
